// Navigation des Moduls `konten` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul konten.
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'konten',
  title: 'Accounts & sign-in',
});
